import AssetService from 'src/lib/api/asset.service';

export async function finishAssetUpload(context, { id }) {
  await AssetService.finishAssetUpload({ id });
}

export async function updateAsset(context, { id, description }) {
  await AssetService.updateAsset({ id, description });
}

export async function deleteAsset(context, { id }) {
  await AssetService.deleteAsset({ id });
}
